import { Component, ElementRef, EventEmitter, Input, OnInit, OnChanges, Output, ViewChild } from '@angular/core';
import { DatePipe } from '@angular/common';
import { HttpParams } from '@angular/common/http';
import { DataService, EmmiterService } from 'src/app/services/data.service';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
//import { NgwWowService } from 'ngx-wow';
import { CommonService } from 'src/app/services/common.service';
import { Response } from 'src/app/models/response.model';
import { ConfirmationDialogComponent } from 'src/app/shared/components/confirmation-dialog/confirmation-dialog.component';
import {MemoryStorageService} from 'src/app/services/memory-storage.service';


@Component({
  selector: 'app-proxy',
  templateUrl: './proxy.component.html',
  styleUrls: ['./proxy.component.css']
})

export class ProxyComponent implements OnInit {

  lstRequestType = [];
  lstUser = [];
  lstRole = [];

  lstProxyUser = [];
  lstStatus = [];
  lstProxyDetails: any = {};

  lstHistory: any = [];
  lstProxyTrail: any = [];
  proxyHistoryColumnsToHide: any = ['proxyId'];
  selectedRequestType: any = {};
  selectedUser: any = {};
  selectedRole: any = {};

  selectedProxyUser: any = {};
  selectedStatus: any = {};

  dateFormat = new DatePipe('en-US');
  minToDate: Date = new Date();
  minFromDate: Date = new Date();
  fromDate: Date;
  toDate: Date;
  proxyId: number = 0;

  isSubmitEnable: boolean = true;
  isShowHistory: boolean = false;
  isshowProxyTrail: boolean = false;
  isshowstatus: boolean = false;
  constructor(
    public commonService: CommonService,
    private dataService: DataService,
    private dialog: MatDialog,
    private router: Router,
    private memorystore: MemoryStorageService
  ) {

  }


  ngOnInit(): void {
    this.selectedStatus.name = 'ACTIVE';
    this.enableSubmitButton();
    this.fillProxyDetails();
    this.fillStatusList();
    this.onHistoryShowButtonClick();
  }


  fillRequestTypeList() {
    this.lstRequestType = [];
    if (this.lstProxyDetails.table0 != null && this.lstProxyDetails.table0 != undefined) {
      this.lstRequestType = this.lstProxyDetails.table0;
    }
  }

  fillUserList() {
    this.lstUser = [];
    if (this.lstProxyDetails.table1 != null && this.lstProxyDetails.table1 != undefined) {
      this.lstUser = this.lstProxyDetails.table1;
    }
  }

  fillRoleList(userSelected: any) {
    this.lstRole = [];
    this.selectedRole = {};
    if (this.lstProxyDetails.table2 != null && this.lstProxyDetails.table2 != undefined) {
      this.lstProxyDetails.table2.filter(p => p.user_id == userSelected.id).forEach((q) => {
        this.lstRole.push({ "id": q.id, "name": q.name });
      });
    }
  }

  fillProxyUserList(roleSelected: any) {
    this.lstProxyUser = [];
    this.selectedProxyUser = {};
    if (this.lstProxyDetails.table3 != null && this.lstProxyDetails.table3 != undefined) {
      this.lstProxyDetails.table3.filter(p => p.role_id == roleSelected.id && p.id != this.selectedUser.id).forEach((q) => {
        this.lstProxyUser.push({ "id": q.id, "name": q.name });
      });
    }
  }

  fillStatusList() {
    this.lstStatus = [];
    this.lstStatus.push({ id: 1, name: 'Active' });
    this.lstStatus.push({ id: 2, name: 'Inactive' });
  }

  onSelectRequestType(request) {
    this.selectedRequestType = request;
    this.enableSubmitButton();
  }

  onUserChange(user) {
    this.selectedUser = user;
    if (this.selectedUser.id > 0) {
      this.fillRoleList(this.selectedUser);
    }
    this.enableSubmitButton();
  }

  onRoleChange(role) {
    this.selectedRole = role;
    if (this.selectedRole.id > 0) {
      this.fillProxyUserList(this.selectedRole);
    }
    this.enableSubmitButton();
  }

  onProxyUserChange(proxyUser) {
    this.selectedProxyUser = proxyUser;
    this.enableSubmitButton();
  }

  onStatusChange(status) {
    this.selectedStatus = status;
    this.enableSubmitButton();
  }

  cellClickEvent(event: any) {
    if (event.columnName == "Edit") {
      this.proxyId = event.rowData['proxyId'];

      this.lstRequestType = [];
      if (this.lstProxyDetails.table0 != null && this.lstProxyDetails.table0 != undefined) {
        this.lstRequestType = this.lstProxyDetails.table0;
      }
      this.selectedRequestType = this.lstRequestType.find((x) => x.name.toLowerCase() == event.rowData['Request Type'].toLowerCase());

      this.lstUser = [];
      this.selectedUser = {};
      if (this.lstProxyDetails.table1 != null && this.lstProxyDetails.table1 != undefined) {
        this.lstUser = this.lstProxyDetails.table1;
      }
      this.selectedUser = this.lstUser.find((x) => x.name.toLowerCase() == event.rowData['User Name'].toLowerCase());

      this.lstRole = [];
      this.selectedRole = {};
      this.lstProxyDetails.table2.filter(p => p.user_id == this.selectedUser.id).forEach((q) => {
        this.lstRole.push({ "id": q.id, "name": q.name });
      });
      this.selectedRole = this.lstRole.find((x) => x.name.toLowerCase() == event.rowData['Role Name'].toLowerCase());

      this.selectedProxyUser = {};
      this.lstProxyUser = [];
      if (this.lstProxyDetails.table3 != null && this.lstProxyDetails.table3 != undefined) {
        this.lstProxyDetails.table3.filter(p => p.role_id == this.selectedRole.id && p.id != this.selectedUser.id).forEach((q) => {
          this.lstProxyUser.push({ "id": q.id, "name": q.name });
        });
      }
      this.selectedProxyUser = this.lstProxyUser.find((x) => x.name.toLowerCase() == event.rowData['Proxy User Name'].toLowerCase());
      this.selectedStatus = this.lstStatus.find((x) => x.name.toLowerCase() == event.rowData['Status'].toLowerCase());

      let fieldFromValue = this.dateFormat.transform(event.rowData['From Date'], 'dd/MMM/yyyy').toString();
      let fieldToValue = this.dateFormat.transform(event.rowData['To Date'], 'dd/MMM/yyyy').toString();

      this.fromDate = new Date(fieldFromValue);
      this.toDate = new Date(fieldToValue);

      this.enableSubmitButton();
    }
    if (event.columnName == "Delete") {

      let selectedLineIDs = 0

      const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
        disableClose: true,
        data: {
          message: 'Are you sure, do wants to delete the record?',
          buttonText: {
            ok: 'Yes',
            cancel: 'No',
          },
        },
      });
      dialogRef.afterClosed().subscribe((confirmed: boolean) => {
        if (confirmed) {
          let params = {
            // Project_Id: this.commonService.getUserInfoFromLocalStorage('projectId'),
            // User_Id: this.commonService.getUserInfoFromLocalStorage('userId'),
            Project_Id: this.memorystore.getItem('projectId'),
            User_Id: this.memorystore.getItem('userId'),
            Proxy_Status: 'INACTIVE',
            Proxy_Id: event.rowData.proxyId
          };

          this.dataService.postDataPromise('delete-proxy', params).then(async (res) => {
            if (res != null && (res.error_message == null || res.error_message == "")) {
              if (res != null && res.status == true) {
                this.commonService.showMessageBox("Deleted successfully.");
              }
              this.getHistory();
            }
            else {
              if (res.errorCode != 0 && res.errorCode == 4000) {
                this.router.navigateByUrl('/unauthorized');
                return;
              }
              if (res.errorCode != 0 && res.errorCode == 3000) {
                this.commonService.showMessageBox("Internal error")
              }
            }
          },
            error => {
              if (error.includes("401")) {
                this.router.navigateByUrl('/unauthorized');
                return;
              }
            });
        }
      });
    }

  }

  onHistoryShowButtonClick() {
    this.getHistory();
  }


  async getHistory() {
    this.lstHistory = [];
    this.lstProxyTrail = [];

    let params = new HttpParams();
    params = params.append('project_id', this.commonService.selectedProject);
    await this.dataService.getDataPromise('proxy-history', params).then(
      async (res) => {
        if (res != null && (res.error_message == null || res.error_message == "")) {
          if (res != null && res != undefined) {
            this.isShowHistory = true;


            res.data.Table.forEach(async (element) => {
              this.lstHistory.push({
                "proxyId": element.proxyId,
                "User Name": element.userName,
                "Role Name": element.roleName,
                "Proxy User Name": element.proxyUserName,
                "From Date": this.dateFormat.transform(element.fromDate, 'dd/MMM/yyyy').toString(),
                "To Date": this.dateFormat.transform(element.toDate, 'dd/MMM/yyyy').toString(),
                "Created On": this.dateFormat.transform(element.createdOn, 'dd/MMM/yyyy HH:mm').toString(),
                "Created By": element.createdBy,
                "Request Type": element.requestType,
                "Status": element.status,
                "Delete": "Delete"
              });
            });
            if (res.data.Table1 != undefined) {

              res.data.Table1.forEach(async (element) => {
                this.lstProxyTrail.push({
                  "proxyId": element.proxyId,
                  "User Name": element.userName,
                  "Role Name": element.roleName,
                  "Proxy User Name": element.proxyUserName,
                  "From Date": this.dateFormat.transform(element.fromDate, 'dd/MMM/yyyy').toString(),
                  "To Date": this.dateFormat.transform(element.toDate, 'dd/MMM/yyyy').toString(),
                  "Created On": this.dateFormat.transform(element.createdOn, 'dd/MMM/yyyy HH:mm').toString(),
                  "Created By": element.createdBy,
                  "Request Type": element.requestType,
                  "Status": element.status
                });
              });
              if (this.lstProxyTrail.length > 0) {
                this.isshowProxyTrail = true;
              }
            }
          }
          else {
            this.isShowHistory = false;
          }
        }
        else {
          if (res.errorCode != 0 && res.errorCode == 4000) {
            this.router.navigateByUrl('/unauthorized');
            return;
          }
          if (res.errorCode != 0 && res.errorCode == 3000) {
            this.commonService.showMessageBox("Internal error")
          }
        }
      },
      error => {
        if (error.includes("401")) {
          this.router.navigateByUrl('/unauthorized');
          return;
        }
      }
    );

  }
  async onSubmitButtonClick() {
    let isSubmitValid = true;
    let invalidSubmitMsg = '';

    if (
      this.selectedRequestType.name == '' ||
      this.selectedRequestType.name == undefined ||
      this.selectedRequestType.name == null
    ) {
      invalidSubmitMsg += 'Please select request type\r <br/>';
      isSubmitValid = false;
    }

    if (
      this.selectedUser.name == '' ||
      this.selectedUser.name == undefined ||
      this.selectedUser.name == null
    ) {
      invalidSubmitMsg += 'Please select user\r <br/>';
      isSubmitValid = false;
    }

    if (
      this.selectedRole.name == '' ||
      this.selectedRole.name == undefined ||
      this.selectedRole.name == null
    ) {
      invalidSubmitMsg += 'Please select role\r <br/>';
      isSubmitValid = false;
    }
    if (
      this.dateFormat.transform(this.fromDate, 'dd/MMM/yyyy') == '' ||
      this.dateFormat.transform(this.fromDate, 'dd/MMM/yyyy') == undefined ||
      this.dateFormat.transform(this.fromDate, 'dd/MMM/yyyy') == null
    ) {
      invalidSubmitMsg += 'Please select from date\r <br/>';
      isSubmitValid = false;
    }
    if (
      this.dateFormat.transform(this.toDate, 'dd/MMM/yyyy') == '' ||
      this.dateFormat.transform(this.toDate, 'dd/MMM/yyyy') == undefined ||
      this.dateFormat.transform(this.toDate, 'dd/MMM/yyyy') == null
    ) {
      invalidSubmitMsg += 'Please select to date\r <br/>';
      isSubmitValid = false;
    }

    if (
      this.fromDate > this.toDate
    ) {
      invalidSubmitMsg += 'Please select to date greater than from date\r <br/>';
      isSubmitValid = false;
    }

    if (
      this.selectedProxyUser.name == '' ||
      this.selectedProxyUser.name == undefined ||
      this.selectedProxyUser.name == null
    ) {
      invalidSubmitMsg += 'Please select proxy user\r <br/>';
      isSubmitValid = false;
    }
    if (
      this.selectedStatus.name == '' ||
      this.selectedStatus.name == undefined ||
      this.selectedStatus.name == null
    ) {
      invalidSubmitMsg += 'Please select status\r <br/>';
      isSubmitValid = false;
    }
    if (!isSubmitValid) {
      this.commonService.showMessageBox(invalidSubmitMsg, 'Alert');
      return;
    }

    this.selectedStatus.name = 'ACTIVE';
    let params = {
      // Project_Id: this.commonService.getUserInfoFromLocalStorage('projectId'),
      Project_Id: this.memorystore.getItem('projectId'),
      Role_Id: this.selectedRole.id,
      User_Id: this.selectedUser.id,
      ProxyUser_Id: this.selectedProxyUser.id,
      Proxy_From_Dt: this.dateFormat.transform(this.fromDate, 'dd/MMM/yyyy').toString(),
      Proxy_To_Dt: this.dateFormat.transform(this.toDate, 'dd/MMM/yyyy').toString(),
      Status: this.selectedStatus.name,
      Created_Dt: this.dateFormat.transform(new Date(), 'dd/MMM/yyyy').toString(),
      // Created_By: this.commonService.getUserInfoFromLocalStorage('userId'),
      Created_By: this.memorystore.getItem('userId'),
      Request_Type: this.selectedRequestType.name,
      Subgroup_Id: this.commonService.selectedSubgroup,
      Proxy_Id: this.proxyId
    };

    await this.dataService.postDataPromise('proxy', params).then(async (res) => {
      if (res != null && (res.error_message == null || res.error_message == "")) {
        if (res.status == true) {
          let objData: any = {};
          objData =
            {
              "proxyId": res.data,
              "User Name": this.selectedUser.name,
              "Role Name": this.selectedRole.name,
              "Proxy User Name": this.selectedProxyUser.name,
              "From Date": this.dateFormat.transform(this.fromDate, 'dd/MMM/yyyy').toString(),
              "To Date": this.dateFormat.transform(this.toDate, 'dd/MMM/yyyy').toString(),
              "Created On": this.dateFormat.transform(new Date(), 'dd/MMM/yyyy HH:mm').toString(),
              // "Created By": this.commonService.getUserInfoFromLocalStorage('userName'),
              "Created By": this.memorystore.getItem('userName'),
              "Request Type": this.selectedRequestType.name,
              "Status": this.selectedStatus.name,
              "Edit": "Edit"
            };
          let displayType = this.selectedRequestType.name == "PROXY" ? "Proxy" : "Proxy";
          if (this.proxyId > 0) {
            this.commonService.showMessageBox(displayType + " updated successfully", 'Information');
          }
          else {
            this.commonService.showMessageBox(displayType + " added successfully", 'Information');
          }

          this.isShowHistory = true;

          // if(this.lstHistory.length == 0){
          //   this.lstHistory=[];
          //   this.lstHistory.push(objData);
          // }
          // else{

          //   this.lstHistory.push(objData);
          // }    
          this.getHistory();
          this.onResetButtonClick();

        }
        else {
          this.commonService.showMessageBox(res.data, 'Alert');
        }
      }
      else {
        if (res.errorCode != 0 && res.errorCode == 4000) {
          this.router.navigateByUrl('/unauthorized');
          return;
        }
        if (res.errorCode != 0 && res.errorCode == 3000) {
          this.commonService.showMessageBox("Internal error")
        }
      }
    },
      error => {
        if (error.includes("401")) {
          this.router.navigateByUrl('/unauthorized');
          return;
        }
      });
  }

  enableSubmitButton() {
    this.isSubmitEnable = false;
    if (
      this.selectedRequestType.name == '' ||
      this.selectedRequestType.name == undefined ||
      this.selectedRequestType.name == null
    ) {
      this.isSubmitEnable = true;
    }

    if (
      this.selectedUser.name == '' ||
      this.selectedUser.name == undefined ||
      this.selectedUser.name == null
    ) {
      this.isSubmitEnable = true;
    }

    if (
      this.selectedRole.name == '' ||
      this.selectedRole.name == undefined ||
      this.selectedRole.name == null
    ) {
      this.isSubmitEnable = true;
    }
    if (
      this.dateFormat.transform(this.fromDate, 'dd/MMM/yyyy') == '' ||
      this.dateFormat.transform(this.fromDate, 'dd/MMM/yyyy') == undefined ||
      this.dateFormat.transform(this.fromDate, 'dd/MMM/yyyy') == null
    ) {
      this.isSubmitEnable = true;
    }
    if (
      this.dateFormat.transform(this.toDate, 'dd/MMM/yyyy') == '' ||
      this.dateFormat.transform(this.toDate, 'dd/MMM/yyyy') == undefined ||
      this.dateFormat.transform(this.toDate, 'dd/MMM/yyyy') == null
    ) {
      this.isSubmitEnable = true;
    }

    if (
      this.selectedProxyUser.name == '' ||
      this.selectedProxyUser.name == undefined ||
      this.selectedProxyUser.name == null
    ) {
      this.isSubmitEnable = true;
    }
    if (
      this.selectedStatus.name == '' ||
      this.selectedStatus.name == undefined ||
      this.selectedStatus.name == null
    ) {
      this.isSubmitEnable = true;
    }

  }
  onResetButtonClick() {
    this.selectedRequestType = {};
    this.selectedUser = {};
    this.selectedRole = {};
    this.selectedProxyUser = {};
    this.selectedStatus = {};

    this.fromDate = null;
    this.toDate = null;
    this.fillProxyDetails();
    this.fillRequestTypeList();
    this.fillUserList();
    this.fillStatusList();
    this.lstRole = [];
    this.lstProxyUser = [];
    this.proxyId = 0;
    this.isSubmitEnable = true;
  }

  async fillProxyDetails() {
    this.lstProxyDetails = {};
    let params = new HttpParams();
    params = params.append('project_id', this.commonService.selectedProject);
    params = params.append('role_id', this.commonService.selectedRole);

    await this.dataService.getDataPromise('proxy-details', params).then(
      (res) => {
        if (res != null && (res.error_message == null || res.error_message == "")) {
          this.lstProxyDetails = res.data;
          this.fillRequestTypeList();
          this.fillUserList();
        }
        else {
          if (res.errorCode != 0 && res.errorCode == 4000) {
            this.router.navigateByUrl('/unauthorized');
            return;
          }
          if (res.errorCode != 0 && res.errorCode == 3000) {
            this.commonService.showMessageBox("Internal error")
          }
        }
      },
      error => {
        if (error.includes("401")) {
          this.router.navigateByUrl('/unauthorized');
          return;
        }
      }
    );
  }
}
